import React, { PropTypes } from 'react';
import _ from 'underscore';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import LoaderWithText from '../LoaderWithText';
import InlineValidationMessage from '../InlineValidationMessage';
import { itemsPropTypes } from '../commonPropTypes';

const SelectWithLoading = React.createClass({
    propTypes: {
        placeholder: PropTypes.string,
        items: itemsPropTypes,
        isLoading: PropTypes.bool,
        loadingError: PropTypes.string,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        autoFocus: PropTypes.bool,
    },
    componentWillUpdate: function (nextProps) {
        const currentValue = this.props.value;
        const newValue = nextProps.value;

        if(!isUndefinedNullOrEmpty(currentValue) && currentValue === newValue) {
            const item = _(nextProps.items).find(x => x.id === currentValue);
            if(!isUndefinedNullOrEmpty(item) && item.disabled === true) {
                this.props.onChange('');
            }
        }
    },
    render: function() {
        const { items, value, disabled, autoFocus, onChange, isLoading, placeholder, loadingError } = this.props;
        const placeholderToUse = isUndefinedNullOrEmpty(placeholder) ? 'Select an option' : placeholder;
        const noLoadingError = isUndefinedNullOrEmpty(loadingError);

        return <div> 
            {(!isLoading && noLoadingError) && <select className="selector" value={value} onChange={onChange} ref="selectElement" disabled={disabled || isLoading} autoFocus={autoFocus}>
                <option value="" disabled hidden>{placeholderToUse}</option>
                {!isLoading && items.map(item =>
                    <option key={item.id} value={item.id} disabled={item.disabled}>{item.name}</option>
                )}
            </select>}
            {(isLoading && noLoadingError) && <LoaderWithText loadingText="Loading" />}
            {!noLoadingError && <InlineValidationMessage touched={true} error={loadingError} />}
        </div>;
    }
});

export default SelectWithLoading;



// WEBPACK FOOTER //
// ./src/components/common/SelectWithLoading/index.jsx